import { displayToast } from '../../../../helpers/notification';
import { FeaturedContentTypes as Type } from '../../../types/featuredcontent';

export function deleteFeaturedContentRequest(id: string) {
  return {
    type: Type.DELETE_FEATURED_CONTENT_REQUEST,
    id,
  };
}

export function deleteFeaturedContentRequestSuccess(data: any) {
  return {
    type: Type.DELETE_FEATURED_CONTENT_REQUEST_SUCCESS,
    payload: data,
  };
}

export function deleteFeaturedContentRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.DELETE_FEATURED_CONTENT_REQUEST_FAILURE,
    error: error,
  };
}

export function resetDeleteFeaturedContentRequest() {
  return {
    type: Type.RESET_DELETE_FEATURED_CONTENT_REQUEST,
  };
}
